<template>
  <transition name="fade" mode="out-in">
    <router-view :statusFixo="statusFixo" :statusModal="statusModal" v-on:changeTipo="changeTipo"></router-view>
  </transition>
</template>
<script>
  export default {
    data(){
      return{
        checkLogin: false,
        statusFixo: "",
        statusModal: "",
        tipoModal: "",
      }
    },
    methods:{
      changeTipo(tipo){
        this.tipoModal = tipo;
        this.$emit("changeTipo", this.tipoModal);  
      }
    },
    updated(){
      this.$emit('changeContent',this.$route.path);
      this.$emit('loginComplete');
      this.statusFixo = this.$route.query.filtrarFixo;
      this.statusModal = this.$route.query.filtrarDinamico;
    },mounted(){
      this.$emit('changeContent',this.$route.path);
      this.$emit('loginComplete');
      this.statusFixo = this.$route.query.filtrarFixo;
      this.statusModal = this.$route.query.filtrarDinamico;
    }
  }
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
